// extracted by mini-css-extract-plugin
export default {"disabled":"index_disabled__Oyxvh"};